import React from 'react';
import PromokodiBlock from '../../components/PromokodiBlock'
import PageLayout from '../../components/PageLayout';

export default function FederationadministratorComissionPromocodes(props) {
    return (
        <PageLayout>
        <PromokodiBlock {...props} source={"/api/promokodi/list/fed?detail=model"}
                sourceKey="fed"
                create={true}
                ctx={{organizatorFederatsiyaID: 1}}
                // context={{
                //     mix: (item) => {
                //         return {
                //             organizatorFederatsiyaID: 1, // Организатор федерация
                //         }
                //     }
                // }}
            />
            </PageLayout>
    );
}
